import {DataGrid} from "@mui/x-data-grid";
import { Paper, Typography, Button, FormControl, InputLabel, Select, MenuItem, TextField, FormGroup} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
//import {useDispatch} from "react-redux"
import {useEffect, useState} from "react"
import {CSVLink} from "react-csv"
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import { fetchTaskbycreateddate, fetchEmployees, fetchTaskbyupdateddate, fetchopentasks, fetchTaskbyassigned, fetchTaskbystatus, fetchTaskbyassignedby, fetchtaskbytripid } from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      height: theme.spacing(4),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      justifyContent: "center",
    },
    formgroup: {
        justifyContent: "center",   
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
}));

const Listtaskdata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
//console.log(width);
const columns = [
    {
      field: "task_id",
      headerName: " Ticket ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
     {
      field: "trip_id",
      headerName: "Trip Id",
      width: width / 12,
    },
    {
      field: "task_description",
      headerName: "Description",
      width: width / 12*4,
    },
    {
      field: "task_status",
      headerName: "Ticket Status",
      width: width / 12,
    },
    {
      field: "task_priority",
      headerName: "Ticket Priority",
      width: width / 12*1,
    },
    {
      field: "deadline_date",
      headerName: "Deadline Date",
      width: width / 12*1,
    },
   
    {
      field: "assigned_by",
      headerName: "Assigned By",
      width: width / 12*1,
    },
    {
      field: "assigned_to",
      headerName: "Assigned To",
      width: width / 12*1,
    },
    {
      field: "time_to_creation",
      headerName: "Time Passed",
      width: width / 12*1,
    },
  ];

  const headers=[
  {label:"Task Id", key:"task_id"},
  {label:"Description", key:"task_description"},
  {label:"Status", key:"task_status"},
  {label:"Priority", key:"task_priority"},
  {label:"Deadline Date", key:"deadline_date"},
  {label:"Trip Id", key:"trip_id"},
  {label:"Assigned By", key:"assigned_by"},
  {label:"Assigend To", key:"assigned_to"},
  {label:"Time to Creation", key:"time_to_creation"},
  ]
  
  const [listtaskData, setlisttaskData] =useState([]);
  const [emp, setemp] =useState([]);
    const [leadfilterData, setleadfilterData]=useState({
        datetype:""
    })
  
  const loadtasks = async () => {
    try{
    console.log(leadfilterData)
    if(leadfilterData.datetype=="Created Date" ) {
      const data = await fetchTaskbycreateddate(leadfilterData.start_date, leadfilterData.end_date);
      console.log(data.data)
      //const custdatalistfromdb= data.data
      setlisttaskData(data.data)
      }else if(leadfilterData.datetype=="Updated Date"){
        const data = await fetchTaskbyupdateddate(leadfilterData.start_date, leadfilterData.end_date);
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlisttaskData(data.data)
    
      }else if(leadfilterData.datetype=="Assigned To"){
        const data = await fetchTaskbyassigned(leadfilterData.assigned_to);
        console.log(data.data)
      setlisttaskData(data.data)
      }else if(leadfilterData.datetype=="All Active"){
        const data = await fetchTaskbystatus(leadfilterData.status);

      setlisttaskData(data.data)
      }else if(leadfilterData.datetype=="Assigned By"){
        const data = await fetchTaskbyassignedby(leadfilterData.assigned_to);

      setlisttaskData(data.data)
      }
      if("trip_id" in leadfilterData){
      const data=await fetchtaskbytripid((leadfilterData.trip_id))
        //console.log(data.data)
        setlisttaskData(data.data)
      }
    }catch(err){
      console.log(err)
    }
  }

  const getEmployees = async () => {
    try{
    const data = await fetchEmployees();
    //const custdatalistfromdb= data.data

    const empsplist = data.data.filter((emp) => emp.role !== "Ex-employee" );
    const empshortname = empsplist.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    //setemp(sortedemp);
    //setsplist(sortedemp);
    setemp(sortedemp);
  }catch(err){
    console.log(err)
  }
  };

  var { cuser, role } = GetRole();
 
  const gettasks=async()=>{
    try{
    const data=await fetchopentasks()
    setlisttaskData(data.data)
    }catch(err){
      console.log(err)
    }
  }
  
  const taskdatalistdisplay=listtaskData.map(task=>({
    id: listtaskData.indexOf(task),
  task_id:task.task_id,
  task_status:task.task_status,
  task_priority:task.task_priority,
  deadline_date:task.deadline_date,
  trip_id:task.trip_id,
  task_description:task.task_description,
  assigned_by:task.assigned_by,
  assigned_to:task.assigned_to,
  time_to_creation:((new Date().getTime()-new Date(task.createdAt).getTime())/(1000*60*60)).toFixed(1)
 }));

 useEffect(() => {
  getEmployees()
  gettasks()
  
}, [])
  //console.log(custdatalistfromdb);

  const gridcelldoubleclicktask=(id)=>{
    window.open("/taskdataentry/"+id, "_blank");
    //console.log("/custdataentry/"+id);
  }


    return ( 
      <div>
     
        <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          View Tickets
        </Typography>
        <div align="center">
        <FormGroup row className={classes.formgroup}>
        <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="DateType">DateType</InputLabel>
            <Select
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="DateType"
              value={leadfilterData.datetype}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, datetype: e.target.value })
              }
            >
            <MenuItem value={"Created Date"}>Created Date</MenuItem>
            <MenuItem value={"Updated Date"}>Updated Date</MenuItem>
            <MenuItem value={"Assigned To"}>Assigned To</MenuItem>
            <MenuItem value={"Assigned By"}>Assigned By</MenuItem>
            <MenuItem value={"All Active"}>All Active</MenuItem>
            <MenuItem value={""}>Clear</MenuItem>
            </Select>
          </FormControl>
          {leadfilterData && "datetype" in leadfilterData && leadfilterData.datetype=="All Active"?(
          <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Status">Status</InputLabel>
            <Select
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Status"
              value={leadfilterData.status}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, status: e.target.value })
              }
            >
             <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Open"}>Open</MenuItem>
            <MenuItem value={"Waiting"}>Waiting</MenuItem>
            <MenuItem value={"In Progress"}>In Progress</MenuItem>
              <MenuItem value={"Task Done"}>Task Done</MenuItem>
            </Select>
          </FormControl>
          ):("")}
           {leadfilterData && "datetype" in leadfilterData && (leadfilterData.datetype=="Assigned To" || leadfilterData.datetype=="Assigned By")?(
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="task owner">Assign To/By:</InputLabel>
                <Select className={classes.textField} labelId="Ticket Owner"  onChange={(e)=> setleadfilterData({...leadfilterData, assigned_to: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}    
                </Select>
                </FormControl> ):("")}
              {leadfilterData && "datetype" in leadfilterData && (leadfilterData.datetype=="Updated Date" || leadfilterData.datetype=="Created Date")?(<div>
          <TextField
            variant="outlined"
            type="date"
            label="Date On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
                setleadfilterData({ ...leadfilterData, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Date On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
                setleadfilterData({ ...leadfilterData, end_date: e.target.value })
            }
          />
          </div>
          ):("")}
           <TextField
            variant="outlined"
           
            label="Trip Id"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
                setleadfilterData({ ...leadfilterData, trip_id: e.target.value })
            }
          />
          

          <Button
            onClick={loadtasks}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            href={"/taskdataentry"}
          >Create Ticket</Button>
          </FormGroup>
          <FormGroup row className={classes.formgroup}>
          {/* <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="quality">Quality?</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="quality"
              value={searchData6.quality}
              onChange={(e) =>
                setsearchData6({ ...searchData6, quality: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
           <MenuItem value={"Platinum"}>Platinum</MenuItem>
           <MenuItem value={"Diamond"}>Diamond</MenuItem>
           <MenuItem value={"Gold"}>Gold</MenuItem>
           <MenuItem value={"Silver"}>Silver</MenuItem>
           <MenuItem value={"Copper"}>Copper</MenuItem>
           <MenuItem value={"Iron"}>Iron</MenuItem>
           <MenuItem value={"High Quality"}>High Quality</MenuItem> 
            </Select>
          </FormControl> */}
          </FormGroup>
        </div>
        {taskdatalistdisplay.length>1?(<div>
                           <CSVLink data={taskdatalistdisplay} headers={headers}>Download CSV</CSVLink>
                           </div>
                        ):("")}
        {taskdatalistdisplay.length > 0 ? (
          <div style={{ height: 1200, width: "100%" }}>
            <DataGrid
              rows={taskdatalistdisplay}
              onCellDoubleClick={(getValue)=>gridcelldoubleclicktask(getValue.row.task_id)}
              columns={columns}
              autoPageSize
              // pageSize={20}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
   
    </div>
     )
}
 
export default Listtaskdata;